import { Folder } from "lucide-react";
import { Link } from "react-router-dom";
import { ActionButtonGroup } from "@doculegis/shared";
import { cn } from "@/lib/utils";

interface LibraryFolderTileProps {
  title: string;
  to: string;
  actions?: React.ReactNode;
  className?: string;
}

export function LibraryFolderTile({
  title,
  to,
  actions,
  className,
}: LibraryFolderTileProps) {
  const tileSurfaceClass = cn(
    "relative aspect-square w-full overflow-hidden rounded-xl border border-[var(--lm-border-card)] bg-[var(--nav-active-bg)] transition-colors",
    "hover:border-[rgba(147,51,245,0.35)] hover:bg-[rgba(147,51,245,0.16)]",
    "dark:border-indigo-400/20 dark:bg-slate-900/45 dark:shadow-none dark:hover:border-violet-500/40 dark:hover:bg-slate-900/60",
  );

  const tileBody = (
    <div className="flex h-full flex-col items-start justify-center gap-2 p-3 text-left">
      <Folder
        className="h-[4.5rem] w-[4.5rem] shrink-0 fill-[var(--lm-accent)] text-[var(--lm-accent)] dark:fill-[var(--lm-accent)] dark:text-[var(--lm-accent)]"
        strokeWidth={1.25}
        aria-hidden
      />
      <p
        className="w-full min-w-0 truncate text-sm font-medium text-[#0b1120] dark:text-white"
        title={title}
      >
        {title}
      </p>
    </div>
  );

  if (actions) {
    return (
      <div className={cn("w-[140px] max-w-full", className)}>
        <div className={tileSurfaceClass}>
          <Link to={to} className="absolute inset-0 z-0 rounded-xl" aria-label={title} />
          <div className="pointer-events-none relative z-[1] h-full">{tileBody}</div>
          <div className="absolute right-1.5 top-1.5 z-10">
            <ActionButtonGroup className="pointer-events-auto">{actions}</ActionButtonGroup>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cn("w-[140px] max-w-full", className)}>
      <Link to={to} className={cn(tileSurfaceClass, "block")} aria-label={title}>
        {tileBody}
      </Link>
    </div>
  );
}
